/**
 * Formatting shared by the "My creations" screen.
 *
 * Timestamps arrive as NAIVE UTC iso strings — the API serializes
 * `datetime.utcnow()` with no zone — so `new Date()` would read them as LOCAL
 * time and shift the whole history by the timezone offset. The trailing Z is
 * what makes it UTC. (Same trap, same fix, as the admin's aiGenerationFormat.)
 */
export function toDate(value?: string | null): Date | null {
    if (!value) return null;
    const normalized = /[Zz]|[+-]\d{2}:?\d{2}$/.test(value) ? value : `${value}Z`;
    const date = new Date(normalized);
    return isNaN(date.getTime()) ? null : date;
}

/** Short date+time for a card caption. Locale comes from the browser, which is
 *  what the rest of the end-user app does with dates. */
export function formatCreatedAt(value?: string | null): string {
    const date = toDate(value);
    if (!date) return '—';
    return date.toLocaleString(undefined, {
        day: '2-digit', month: '2-digit', year: '2-digit',
        hour: '2-digit', minute: '2-digit',
    });
}

/** ms -> a short human duration. Renders take seconds, not hours. */
export function formatDuration(ms?: number | null): string {
    if (ms === null || ms === undefined) return '—';
    const seconds = ms / 1000;
    if (seconds < 60) return `${seconds.toFixed(1)}s`;
    const minutes = Math.floor(seconds / 60);
    return `${minutes}m ${Math.round(seconds % 60)}s`;
}
